var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCareersImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 447.8 219.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-7{fill:none;}.cls-1{stroke:#33b1ff;stroke-width:2px;}.cls-2{fill:url(#linear-gradient);}.cls-3,.cls-7{stroke-miterlimit:10;}.cls-3{stroke:url(#linear-gradient-2);}.cls-4{fill:#0f62fe;}.cls-5{fill:#33b1ff;}.cls-6{fill:url(#linear-gradient-3);}.cls-7{stroke:url(#linear-gradient-4);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 245.2,
    y1: 872.76,
    x2: 351.07,
    y2: 872.76,
    gradientTransform: "matrix(0.71, 0.71, -0.71, 0.71, 443.14, -790.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#33b1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1108.9,
    y1: 1032.21,
    x2: 1253.79,
    y2: 1032.21,
    gradientTransform: "translate(1134.72 -1109.42) rotate(89.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1c7cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1650.62,
    y1: -557.34,
    x2: 1756.49,
    y2: -557.34,
    gradientTransform: "translate(2009.66 989.95) rotate(-135.07)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1091.45,
    y1: -972.81,
    x2: 1236.34,
    y2: -972.81,
    gradientTransform: "matrix(0, -1, 1, 0, 1318.08, 1308.61)",
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "careers-img") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sencenje"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M308.44,152.65h-44v-88h88v43.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.61,69.15a4.4,4.4,0,0,0-1,2.76,4.5,4.5,0,0,0,9,0,4.51,4.51,0,0,0-1.32-3.18,4.47,4.47,0,0,0-3.19-1.31,4.53,4.53,0,0,0-2.85,1L.71,0,0,.71Zm1.41,0a3.39,3.39,0,0,1,2.13-.73,3.55,3.55,0,0,1,3.5,3.49,3.47,3.47,0,0,1-3.49,3.5,3.48,3.48,0,0,1-3.49-3.49,3.37,3.37,0,0,1,.66-2,2.06,2.06,0,0,1,.35-.42A3.17,3.17,0,0,1,70,69.14Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "176.8 145.1 103.8 145.19 103.71 73.19 31.57 1.24"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mask0_121_2",
    "data-name": "mask0 121 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 231.94,
    cy: 41.18,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M231.94,13.18a28,28,0,1,1-28,28,28,28,0,0,1,28-28m0-4a32,32,0,1,0,32,32,32,32,0,0,0-32-32Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M112.44,107.72V64.65h88v88h-44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M156.44,2.68a26,26,0,1,1-26,26,26,26,0,0,1,26-26m0-2a28,28,0,1,0,28,28,28,28,0,0,0-28-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M308.44,2.68a26,26,0,1,1-26,26,26,26,0,0,1,26-26m0-2a28,28,0,1,0,28,28,28,28,0,0,0-28-28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M275.94,85.15v88h-88v-88h88m4-4h-96v96h96v-96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M379.19,150a4.38,4.38,0,0,0,.95-2.76,4.49,4.49,0,1,0-1.65,3.49l68.6,68.42.71-.71Zm-1.41,0a3.4,3.4,0,0,1-2.14.73,3.55,3.55,0,0,1-3.49-3.49,3.49,3.49,0,1,1,7,0,3.37,3.37,0,0,1-.66,2.05,3,3,0,0,1-.35.43C378,149.86,377.9,150,377.78,150.05Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "271 74.09 344 74 344.09 146 416.23 217.95"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareersImg);
export default __webpack_public_path__ + "static/media/careers-img.3b8c5d685912568637faf309ac676e71.svg";
export { ForwardRef as ReactComponent };